import listRule from 'markdown-it/lib/rules_block/list';

// markdown-it accepts up to 9 digits in an ordered list marker (its own limit
// only guards against integer overflow in `<ol start>`). That is long enough to
// swallow anything a customer types at the start of a line: a message opening
// with `607001964. zavolejte mi` renders as `<ol start="607001964">` instead of
// text, and so do order numbers, amounts and years. Nobody numbers a list past
// 999, so we cap the marker at 3 digits and leave longer runs as plain text.
const MAX_MARKER_DIGITS = 3;

const isDigit = char => char >= '0' && char <= '9';

// Mirrors markdown-it's `skipOrderedListMarker` (which works on char codes for
// speed; we only run once per block-opening line, so plain chars are fine), but
// only to answer "would this line start an ordered list with too many digits?".
const hasOversizedOrderedMarker = (state, startLine) => {
  const start = state.bMarks[startLine] + state.tShift[startLine];
  const max = state.eMarks[startLine];
  let pos = start;

  while (pos < max && isDigit(state.src[pos])) pos += 1;

  // no digits, or digits run to EOL -> not an ordered list marker
  if (pos === start || pos >= max) return false;

  const marker = state.src[pos];
  if (marker !== '.' && marker !== ')') return false;

  return pos - start > MAX_MARKER_DIGITS;
};

export default function orderedListDigitLimit(md) {
  // `alt` has to be repeated here: Ruler#at replaces the options of the rule it
  // overwrites, and dropping the chains would stop lists from terminating
  // paragraphs and blockquotes.
  md.block.ruler.at(
    'list',
    (state, startLine, endLine, silent) => {
      if (hasOversizedOrderedMarker(state, startLine)) return false;
      return listRule(state, startLine, endLine, silent);
    },
    { alt: ['paragraph', 'reference', 'blockquote'] }
  );
}
